

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Timeline, TimelineLite, TimelineMax, TweenMax, TweenLite} from "gsap";
import Sprite = PIXI.Sprite;
import BitmapText = PIXI.BitmapText;
import Point = PIXI.Point;
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export interface IHash {
    [details: string] : Sprite;
}

export class MultiplierBetWinView extends BaseView {

    private _layer:ScalableLayer;

    private _activeSprites:Sprite [] = []; // TODO: Make map instead
    private _symHash:IHash;
    private _mpAndWinArr: Sprite [] = [];

    private _betLineList: string [][] = [];
    private _betLineSetupComplete:boolean = false;

    private _activeBetlineIndexes:number [] = [];



    private _textStyle = {
        fontName : "harleyMultiplier",
        fontSize: 50
    };

    private _textStyleMpAndVal = {
        fontName : "harleyMultiplier",
        fontSize: 42
    };

    private _textStyleMpValSmall:BitmapTextStyleOptions = {
        font: {
            name : "harleyMultiplier",
            size: 36
        }
    };

    constructor() {
        super();

        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.BET_LINES_MP.name);
        this._layer.addChild(this);
    }

    onResize(data:IResizeData) {
        if(data.orientation === Orientation.PORTRAIT) {
            this.scale.set(1, 1);
            //this.position.set(0, 0);
            this.position.set(-280, -210);

            this._mpAndWinArr.forEach((sprite, index) => {
                const symPos:number [] = Helper.getSymbolPositions(2, index);
                sprite.position.set(symPos[0], symPos[1] /*- 100*/);
            });
        } else {
            //this.position.set(80, 136);
            this.position.set(-205, -70);
            this.scale.set(0.85, 0.85);

            this._mpAndWinArr.forEach((sprite, index) => {
                const symPos:number [] = Helper.getSymbolPositions(2, index);
                sprite.position.set(symPos[0], symPos[1] /*- 45*/);
            });
        }
    }

    initAnimations() {
        this._symHash = this.createMultiplierSprites();
    }

    public playMpAnimations(symsForLine:number [][], mpValue:number):Timeline {
        const tl:TimelineLite = new TimelineLite();

        symsForLine.forEach((numArr:number []) => {
            //debugger;
            tl.add(this.playSingleMpAnimation(numArr, "" + mpValue));
        });

        return tl;
    }

    public playSingleMpAnimation(sym: number [], mpString:string): Timeline {
        const tl:TimelineLite= new TimelineLite();

        if(this._symHash["r"+sym[0]+"_s"+sym[1]]) {
            const sprite:Sprite = this._symHash["r"+sym[0]+"_s"+sym[1]];

            tl.add([
                () => {
                    (<BitmapText> sprite.getChildByName("mpText")).text = mpString;
                },
                () => sprite.visible = true,
                TweenMax.fromTo(sprite, 0.2, {
                    alpha: 0
                }, {
                    alpha: 0.8
                })
            ]);

            this._activeSprites.push(sprite);
        }
        return tl;
    }

    public resetAllActives():Timeline {
        const tl:TimelineLite = new TimelineLite();

        this._activeSprites.forEach((sprite) => {
            tl.add(() => TweenLite.to(sprite, 0.2, {
                alpha: 0
            }));
            tl.add([
                () => sprite.visible = false,
                () => {
                    (<BitmapText> sprite.getChildByName("mpText")).text = "";
                }
            ]);
        });

        return tl;
    }

    public setUpBetLines(betlineData:number [][] = []):void {
        if(!this._betLineSetupComplete && betlineData.length > 0) {

            betlineData.forEach((numArr:number [], index:number) => {
                const strArr:string [] = [];

                //console.log("---------------- Per Line --------------");
                //console.log("line index: " + index);
                numArr.forEach((symId:number, reelId:number) => {
                   //console.log("REEL ID: " + reelId + " - SYM ID: " + symId);
                    strArr.push("r"+reelId+"_s"+symId);
                });

                this._betLineList.push(strArr);
            });

            //console.log("Betline String Mapping");
            //console.log(this._betLineList);
            //this._betLineList

        }
    }

    private toggleAllTest():void {
        const tlTest:TimelineLite = new TimelineLite();

        tlTest.add(() => {
            const tl:TimelineMax = new TimelineMax({
                repeat: -1
            });

            this._betLineList.forEach((val, index:number) => {
                tl.add(this.playBetline(index, 2), "+=0.2");
                //tl.add(() => this.resetAllActiveLines());
                tl.add(() => {
                    this.resetBetline(index);
                    //this.resetActiveLines()
                    //this._activeBetlineIndexes.length = 0;
                },"+=0.35")
            })
        });
    }

    public playBetline(betlineIndex:number, mpValue:number = 1, winSymbolCount:number = 0, timeModifier:number = 0, last:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineMax();
        const rootTime:number = 0.375;
        const minLimitModifier:number = 0.125;
        const delay:number = 0.5;

        this.resetActiveLines();

        if(betlineIndex >= 0 && betlineIndex < 20 && mpValue > 1) {

            this._betLineList[betlineIndex].forEach((betLineId, index: number) => {
                if (index < winSymbolCount) {
                    const scale: number = this._symHash[betLineId].scale.x;
                    tl.add(() => {
                        (<BitmapText> this._symHash[betLineId].getChildByName("mpText")).text = "x" + mpValue;
                        this._symHash[betLineId].alpha = 1;
                        this._symHash[betLineId].visible = true;
                    });
                    /*tl.add(() => TweenMax.to(
                        this._symHash[betLineId].scale,
                        0.15,
                        {
                            repeat: 1,
                            yoyo: true,
                            x: scale + .5,
                            y: scale + .5
                        }
                    ))*/
                }
            });

            this._activeBetlineIndexes.push(betlineIndex);
        }
        //console.log("time mod: " + (0.3 - timeModifier));
        if(last) {
            tl.add(() => {
            }, `+=${delay}`);
        }
        else {
            tl.add(() => {
                // TODO: Add numbers as informative members
            }, `+=${((rootTime - timeModifier) > minLimitModifier) ? rootTime - timeModifier : minLimitModifier}`);
        }



        //tl.timeScale(timeScale);
        return tl;
    }

    public resetBetline(betlineIndex:number):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(betlineIndex >= 0 && betlineIndex < 20) {
            //this.resetAllActiveLines();

            this._betLineList[betlineIndex].forEach((betLineId) => {
                tl.add(() => {
                    //if (this._symHash[betLineId] instanceof BitmapText) {
                        (<BitmapText> this._symHash[betLineId].getChildByName("mpText")).text = "";
                        this._symHash[betLineId].alpha = 0;
                        this._symHash[betLineId].visible = false;
                    //}
                });
            });

            //this._activeBetlineIndexes.push(betlineIndex);

        }

        return tl;
    }

    public resetAllLines() {
        this._betLineList.forEach((value, index) => {
            this.resetBetline(index);
        });
        this.hideAllMpAndVal();
    }
    public resetActiveLines():void {

        while(this._activeBetlineIndexes.length > 0) {
            const index:number | undefined = this._activeBetlineIndexes.pop();
            if(index) {
                this._betLineList[index].forEach((betLineId: string) => {
                    this._symHash[betLineId].alpha = 0;
                    this._symHash[betLineId].visible = false;
                });
            }
        }

        /*this._activeBetlineIndexes.forEach((value:number) => {
            this._betLineList[value].forEach((betLineId:string) => {
                this._symHash[betLineId].alpha = 0;
                this._symHash[betLineId].visible = false;
            });
        });*/

        this._activeBetlineIndexes.length = 0;
    }

    protected createMultiplierSprites(): IHash {
        const hash:IHash = {};

        [0, 1, 2, 3, 4].forEach((rId:number) =>{
            [0, 1, 2].forEach((sId:number) => {
                const sprite:Sprite = new Sprite(GameResources.getTextures("mpMedal")[0]);
                //sprite.tint = 0x000;

                sprite.anchor.set(0.45, 0.25);
                // sprite.width = 70;
                // sprite.height = 70;
                const symPos:number [] = Helper.getSymbolPositions(rId, sId);
                //sprite.alpha = 0.8;
                sprite.position.set(symPos[0], symPos[1]);

                const mpText:BitmapText = this.createMpText("1");
                mpText.name = "mpText";
                mpText.anchor = new Point(0.5, -0.5);
                mpText.x = 10;
                sprite.addChild(mpText);

                this.addChild(sprite);
                sprite.visible = false;

                //console.log("Adding sprite to hash: " + "r"+rId+"_s"+sId);
                hash["r"+rId+"_s"+sId] = sprite;
            });
        });

        //console.log(hash);
        return hash;
    }

    public showMpAndVal(symIndex:number, winValue:number, mpValue:number):Timeline {
        const tl:TimelineLite = new TimelineLite();
            //tl.add(() => this.hideAllMpAndVal());
            tl.add(() => {
                if(this._mpAndWinArr[symIndex]) {
                    if(mpValue > 1) {
                        (<BitmapText> this._mpAndWinArr[symIndex].getChildByName("mpText")).text = "x" + mpValue;
                        (<BitmapText> this._mpAndWinArr[symIndex].getChildByName("mpText")).visible = true;
                    } else {
                        (<BitmapText> this._mpAndWinArr[symIndex].getChildByName("mpText")).text = "";
                        (<BitmapText> this._mpAndWinArr[symIndex].getChildByName("mpText")).visible = false;
                    }
                    (<BitmapText> this._mpAndWinArr[symIndex].getChildByName("winText")).text = "" + winValue;
                    this._mpAndWinArr[symIndex].visible = true;
                }
            });
        return tl;
    }

    public hideMpAndVal(symIndex:number):Timeline {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            if(this._mpAndWinArr[symIndex]) {
                this._mpAndWinArr[symIndex].visible = false;
            }
        });
        return tl;
    }

    public hideAllMpAndVal():Timeline {
        const tl:TimelineLite = new TimelineLite();

        this._mpAndWinArr.forEach((sprite, index) => {
            tl.add(() => this.hideMpAndVal(index));
        });

        return tl;
    }

    protected createWinText(text:string) {}

    protected createMpText(text:string = "", mpAndWin:boolean = false):BitmapText {
        const mpText:BitmapText = new BitmapText((!mpAndWin)? "x" + text : text, (!mpAndWin)? this._textStyle : this._textStyleMpAndVal);

        return mpText;
    }


}